// Resolves the Flexible Hero panel `headerSizing` field (Large/Normal/Small/
// Dynamic, see MXP-2076) into one of the three fixed visual sizes rendered by
// SimpleHero / HeroLeadPanel. "Dynamic" steps through the same three sizes
// based on headline length — no per-pixel/continuous shrinking.

export type HeroHeaderSize = "large" | "normal" | "small"

const STATIC_SIZE_MAP: Record<string, HeroHeaderSize> = {
  Large: "large",
  Normal: "normal",
  Small: "small",
}

export const DYNAMIC_LARGE_MAX_LENGTH = 30
export const DYNAMIC_NORMAL_MAX_LENGTH = 60

export function resolveHeroHeaderSize(
  headerSizing: string | null | undefined,
  headerText: string | null | undefined,
): HeroHeaderSize {
  if (headerSizing === "Dynamic") {
    const length = (headerText || "").trim().length
    if (length <= DYNAMIC_LARGE_MAX_LENGTH) return "large"
    if (length <= DYNAMIC_NORMAL_MAX_LENGTH) return "normal"
    return "small"
  }
  return STATIC_SIZE_MAP[headerSizing || "Normal"] || "normal"
}
